import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { KuiModule } from 'app/key-ui';
import { Ng2FilterPipeModule } from 'ng2-filter-pipe';
import { SharedModule } from 'app/shared/shared.module';

import { LoginComponent } from './login.component';
import { OidcAuthService } from 'app/services/oidc/oidc.service';
import { MarkdownToHtmlModule } from 'markdown-to-html-pipe';

@NgModule({
    imports: [
        RouterModule.forChild([{ path: '', component: LoginComponent, }, ]),
        CommonModule,
        KuiModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        Ng2FilterPipeModule,
        MarkdownToHtmlModule,
    ],
    declarations: [
        LoginComponent,
    ],
    providers: [OidcAuthService],
})
export class LoginPageModule { }
